import React from "react";
import PageHeader from "./PageHeader";
import {FormSaveProvider} from "../../features/forms/FormSaveContext";
import FormSaveBar from "../../features/forms/FormSaveBar";
import "./page.css";

const renderAction = (button, index, total) => {
    if (button.node) {
        return <React.Fragment key={button.key || index}>{button.node}</React.Fragment>;
    }
    const variant = button.variant || (index === 0 && total > 0 ? "btn-primary" : "btn-secondary");
    return (
        <button
            key={button.key || button.title || index}
            type="button"
            className={`btn ${variant}`}
            onClick={() => button.action && button.action()}
        >
            {button.icon}
            {button.title}
        </button>
    );
};

/**
 * Каркас страницы админки.
 *
 * Совместим со старым API: `title` и `buttons=[{action, title}]`.
 * Новые возможности: `subtitle`, `actions` (ReactNode), `backTo`, `meta`.
 */
const PageLayout = ({
    title,
    subtitle,
    actions,
    buttons = [],
    backTo,
    backLabel,
    eyebrow,
    meta,
    className,
    children
}) => {
    const actionNodes = actions || (buttons.length > 0
        ? buttons.map((button, index) => renderAction(button, index, buttons.length))
        : null);

    return (
        <FormSaveProvider>
            <div className={`ui-page${className ? " " + className : ""}`}>
                <PageHeader
                    title={title}
                    subtitle={subtitle}
                    actions={actionNodes}
                    backTo={backTo}
                    backLabel={backLabel}
                    eyebrow={eyebrow}
                    meta={meta}
                />
                <FormSaveBar/>
                <div className="ui-page__body">{children}</div>
            </div>
        </FormSaveProvider>
    );
};

export default PageLayout;
